/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reseller_Pricing_BelowInputs */

const id_reseller_pricing_below = /** @type {(inputs: Reseller_Pricing_BelowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Harga jual yang ditandai berada di bawah harga modal.`)
};

const en_reseller_pricing_below = /** @type {(inputs: Reseller_Pricing_BelowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The marked prices are below wholesale.`)
};

/**
* | output |
* | --- |
* | "The marked prices are below wholesale." |
*
* @param {Reseller_Pricing_BelowInputs} inputs
* @param {{ locale?: "id" | "en" }} options
* @returns {LocalizedString}
*/
export const reseller_pricing_below = /** @type {((inputs?: Reseller_Pricing_BelowInputs, options?: { locale?: "id" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reseller_Pricing_BelowInputs, { locale?: "id" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_reseller_pricing_below(inputs)
	return id_reseller_pricing_below(inputs)
});